export function formatIndianNumber(num) {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return "—";
  const n = Number(num);
  const isNegative = n < 0;
  const abs = Math.abs(Math.round(n));
  const s = abs.toString();
  let lastThree = s.slice(-3);
  const other = s.slice(0, -3);
  if (other !== "") {
    lastThree = "," + lastThree;
  }
  const formatted = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return `${isNegative ? "-" : ""}${formatted}`;
}

export function formatINR(amount) {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return "—";
  return `₹${formatIndianNumber(amount)}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
